import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "app-card-consultation",
	templateUrl: "./card-dmd.component.html",
})
export class CardConsultaionComponent implements OnInit {
	@Input() consulationID: string;
	@Input() consultationNumero: string;
	@Input() priority: string = "";
	@Input() userImage: string = "./assets/images/users/avatar.png";
	@Input() userName: string;
	@Input() consultaionTitle: string;
	@Input() consultaionDetailsLink: string = "";
	@Input() consultaionDate: string;
	@Input() founisseurCount: number = 0;
	@Input() articlesCount: number = 0;
	@Input() consultant: any;
	@Input() acheteur: any;
	@Input() superieur: any;

	constructor() {}

	ngOnInit() {}
}
